export const LABELS = {
  MAX_DATE_MESSAGE: 'Data não deve ser maior que data limite',
  MIN_DATE_MESSAGE: 'Data não deve ser menor que data limite',
  INVALID_DATE_MESSAGE: 'Formato de data inválido'
};

export default { LABELS };
